// extracted by mini-css-extract-plugin
module.exports = {"component":"_1U8oRUaeznrHT0D5OKSzjx","isActive":"_1fwQHzmJtraxKCwwX0pA0S"};